import { useEffect, useRef } from 'react';

interface UseAssistantSessionUrlSyncProps {
	currentSessionId: string | null;
	questionId: string | null | undefined;
	onSessionStarted: (sessionId: string) => void;
}

/** Writes a newly started session to the URL without reviving an existing session during reset. */
export const useAssistantSessionUrlSync = (props: UseAssistantSessionUrlSyncProps): void => {
	const { currentSessionId, questionId, onSessionStarted } = props;
	const previousSessionIdRef = useRef(currentSessionId);

	useEffect(() => {
		const previousSessionId = previousSessionIdRef.current;
		previousSessionIdRef.current = currentSessionId;

		if (previousSessionId !== null || currentSessionId === null || questionId) return;
		onSessionStarted(currentSessionId);
	}, [currentSessionId, onSessionStarted, questionId]);
};
